import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "element-ui/lib/locale/lang/zh-CN"; // element-ui的中文包
import en from "element-ui/lib/locale/lang/en"; // element-ui的英语包
import { getLanguage, DEFAULT_LANGUAGE } from "../utils/language";

Vue.use(VueI18n); // 全局挂载
// 引入i18n
const i18n = new VueI18n({
    locale: getLanguage(), // 从localStorage中获取 默认中文
    fallbackLocale: DEFAULT_LANGUAGE, // 没有找到匹配的语言将回退到中文
    messages: {
        zh: {
            ...require("./zh"), // 系统中文语言包模块
            ...zh,
        }, // 中文语言包
        en: {
            ...require("./en"), // 系统英语语言包模块
            ...en,
        }, // 英语语言包
        jp: {
            ...require("./jp"), // 系统英语语言包模块
            ...en,
        }, // 英语语言包
    },
});

export default i18n;